import styles from './FloraDocumentSkeleton.module.css';

interface FloraDocumentSkeletonProps {
	lineCount?: number;
	showTitle?: boolean;
}

const LINE_WIDTHS = ['65%', '40%', '72%', '35%', '55%', '45%', '68%', '38%', '60%', '48%'];

export const FloraDocumentSkeleton = ({ lineCount = 6, showTitle = true }: FloraDocumentSkeletonProps) => {
	return (
		<>
			{showTitle && <div className={styles.skeletonTitle} />}
			{Array.from({ length: lineCount }, (_, index) => (
				<div
					key={index}
					className={styles.skeletonLine}
					style={{ width: LINE_WIDTHS[index % LINE_WIDTHS.length] }}
				/>
			))}
		</>
	);
};
